import { MenuItem, MenuItems } from 'app/layouts/layouts.models'
import { Router } from '@angular/router'
import { LoginService } from 'app/users/services/login.service'
import { LayoutService } from 'app/layouts/services/layout.service'

export type IActionType = (router: Router, loginService: LoginService, layoutService: LayoutService) => void
export type ConsumerMenuItems = MenuItems<IActionType>
export type ConsumerMenuItem = MenuItem<IActionType>
